import { Box, Divider, FormLabel, Tag } from "@chakra-ui/react";
import { ColumnDef } from "@tanstack/react-table";
import ActiveTag from "components/ui/ActiveTag";
import ButtonCreateNew from "components/ui/ButtonCreateNew";
import FilterGroup from "components/ui/FilterGroup";
import HeaderBar from "components/ui/HeaderBar";
import SearchInput from "components/ui/SearchInput";
import DynamicTableProvider, {
  useDynamicTableContext,
} from "contexts/DynamicTableContext";
import LayoutParameters from "features/auth/layouts/LayoutParameters";
import React from "react";
import { useParams } from "react-router-dom";
import TagsList from "../components/TagsList";

export default function PageTags() {
  const { type } = useParams();

  const columns = React.useMemo<ColumnDef<any>[]>(
    () => [
      {
        header: "Nome",
        accessorKey: "name",
        cell: ({ row }) => (
          <Tag colorScheme={row.original.colorScheme}>{row.original.name}</Tag>
        ),
      },
      {
        header: "Status",
        accessorKey: "active",
        cell: ({ row }) => <ActiveTag isActive={row.original.active} />,
      },
    ],
    []
  );
  return (
    <LayoutParameters>
      <DynamicTableProvider
        columns={columns}
        resource={{
          resourceName: "tags",
          path: `tags/${type}`,
          params: {
            type,
          },
        }}
        tableOptions={{
          enableGlobalFilter: false,
        }}
      >
        <HeaderBar
          title={`${
            type === "CONTENT" ? "Report" : "Listas de Disparo"
          } → Tags`}
          description="Visualize a lista de tags Patri"
          px="0"
          sx={{
            h1: {
              mt: "0",
            },
          }}
        >
          <ButtonCreateNew title="Cadastrar nova" to={`/tags/${type}/novo`} />
        </HeaderBar>

        <Divider />

        <Box pt="24px">
          <Filters />
          <TagsList />
        </Box>
      </DynamicTableProvider>
    </LayoutParameters>
  );
}

function Filters() {
  const { table } = useDynamicTableContext();

  return (
    <FilterGroup justifyContent="space-between" pos="relative">
      <Box flex={1} minW="180px">
        <FormLabel>Buscar</FormLabel>
        <SearchInput
          placeholder="Buscar por nome"
          onChange={(value) =>
            table.getColumn("name")?.setFilterValue(String(value))
          }
        />
      </Box>
    </FilterGroup>
  );
}
